import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  stepOne_container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%",
  },

  mobile_stepOne_container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%",
    padding: "0px 20px",
  },

  title_container_stepOne: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "100%",
    fontSize: "35px",
    marginTop: "40px",
    marginBottom: "42px",
  },

  mobile_title_container_stepOne: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    marginBottom: "32px",
    width: "100%",
    fontWeight: "bold",
    fontSize: "26px",
    marginTop: "20px",
  },

  stepOne_firstRow: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-end",
    gap: "41px",
    marginBottom: "64px",
  },

  mobile_stepOne_firstRow: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "24px",
    marginBottom: "24px",
    width: "100%",
  },

  stepOne_inputs_container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "32px",
  },

  mobile_stepOne_inputs_container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "revert",
    alignItems: "center",
    height: "100%",
    gap: "32px",
    width: "100%",
    marginBottom: "24px",
  },

  stepOne_radioButtons_container: {},

  firstStep_tempRow: {},

  selectTempLabel: {
    color: "#353535",
    fontSize: "14px",
    letterSpacing: 0,
    marginBottom: "12px",
  },

  tempArray: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "16px",
    marginBottom: "40px",
  },

  calculateButton_container: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    width: "100%",
    marginBottom: "32px",
  },

  inputWrapper: {
    width: "324px",
  },

  mobile_inputWrapper: {
    width: "100%",
  },

  boldText: {
    fontWeight: "bold",
    fontSize: "26px",
  },
}));

export default useStyles;
